import { MediaItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { RocheNewsImporterListItem } from '../../search/data-search/list-items/news-importer-list-item';
import { fetchNewsList, fetchNewsSearch, fetchNewsTabs } from '../../search/data-search/queries';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

export const RocheMediaReleases = ({ slot }: Props): JSX.Element => {
  return (
    <DataSearchView<MediaItem>
      slot={slot}
      searchTrackingType={SearchTrackingType.MEDIA_RELEASES}
      tabName='year'
      pageName='page'
      showInput={true}
      queryName='query'
      fetchTabs={fetchNewsTabs}
      fetchList={fetchNewsList}
      fetchSearch={fetchNewsSearch}
      itemRenderer={(item, index, trackingData) => (
        <RocheNewsImporterListItem key={`${item.Slug}-${index}`} item={item} trackingData={trackingData} />
      )}
    />
  );
};
